const dataSliders = [
    {
        id: 1,
        img: 'ashtanga',
        name: 'Ashtanga Primary Series',
        description:`Ashtanga is a very dynamic and athletic form of hatha yoga, 
        made up of six series or levels, with a fixed order of postures. 
        It is rooted in vinyasa, the flowing movements between postures, 
        with a focus on energy and breath. While it is a very physical practice,
        it also promotes mental clarity and inner peace.`,
    category: "experienced practioners",
    days: "Monday/Wed/Friday",
    time: '7:30 AM'
    },

    {
            id: 2,
            img: 'hatha-yoga',
            name: 'Hatha Yoga',
            description:`Hatha yoga focuses on posture and breathing techniques, 
            traditionally to channel vital energy source. 
            In Sanskrit, Hatha translates to force.
             The practice involves breath, body, and mind, 
             and classes are usually 45 minutes to 90 minutes of 
             breathing, yoga poses, and meditation.`,
             category: "all levels",
             days: "Monday/Wednesday/Saturday",
             time: '9:45 AM'
            },

    {
                id: 3,
                img: 'kundalini-yoga',
                name: 'Kundalini Yoga',
                description:`Kundalini yoga is a form of yoga that involves chanting, singing, 
                breathing exercises, and repetitive poses. 
                Its purpose is to activate your Kundalini energy, or shakti. 
                This is a spiritual energy that's said to be located at the base of your spine.`,
                category: "all levels",
                days: "Tuesday/Thursday",
                time: '06:30 PM'
            },

                {
                    id: 4,
                    img: 'vinyasa-yoga',
                    name: 'Vinyasa',
                    description:` Vinyasa Flow yoga emphasizes the sequential movement between postures, 
                    coordinated with and guided by deliberate breath.
                     The Vinyasa practice becomes a moving meditation that creates strength, 
                     freedom and fluidity in the body and mind.`,
                     category: "all levels",
                     days: "Tuesday/Thursday",
                     time: '08:30 AM'
                 },
                    

                     {
                        id: 5,
                        img: 'singing-bowls-set',
                        name: 'Tibetan Singing Bowls Session',
                        description:` Tibetan singing bowls and their unique tones are used 
                        to stabilise blood pressure, to ease asthma related issues,
                         to renew the functioning of the adrenal gland, 
                        to open and stabilise the meridians and to improve the synaptic responses in our brain.`,
                        category: "all levels",
                        days: "private session",
                        time: 'conatct us to make an appointment'
                    },
                

                        {
                            id: 6,
                            img: 'meditation',
                            name: 'Meditation',
                            description:` 
                            Meditation can produce a deep state of relaxation and a tranquil mind. 
                            During meditation, you focus your attention and eliminate 
                            the stream of jumbled thoughts that may be crowding your mind and causing stress.
                             This process may result in enhanced physical and emotional well-being.`,
                             category: "all levels",
                             days: "Wednesday/Friday",
                time: '07:30 PM'
            },
                            

                             {
                                id: 7,
                                img: 'reiki-healing',
                                name: 'Rreiki-healing',
                                description:` Reiki is an energy healing technique in which a Reiki master 
                                (who has undergone formal training in this healing art) 
                                uses gentle hand movements with the intention to guide the flow of healthy energy 
                                (what's known in Reiki as life force energy) 
                                through the client's body to reduce stress and promote healing.`,
                                category: "all levels",
                                days: "private session",
                                time: 'conatct us to make an appointment'
                            },

    ]


export default dataSliders;